import styled from 'styled-components'
import { device } from '../../styles/GlobalVariables'

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 12px;
`

export const Image = styled.img`
  width: 100%;
  height: 169px;
  object-fit: cover;

  ${device.medium} {
    height: 126px;
  }
`

export const PlayButtonOverlay = styled.div<{ theme?: { color?: string } }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  z-index: 10;
  transition: transform 0.2s ease;
  --play-button-color: ${props => props.theme?.color || '#07c7dc'};

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }

  svg {
    width: 100%;
    height: 100%;

    rect {
      fill: var(--play-button-color);
      fillopacity: 0.6;
    }
  }
`
